/* eslint sort-imports-es6-autofix/sort-imports-es6: 0 */
import 'client/css/signup.css';
import 'client/signup/utilities/validationRules';
import '@jumpcloud/ui-components/css';

import { Buffer } from 'buffer';
import ConfigService from 'client/util/ConfigService';
import DataDog from 'client/util/monitoring/DataDog';
import dreamdataBootstrap from 'client/GrowthEngineering/Dreamdata/dreamdataBootstrap';
import EventManager from 'client/GrowthEngineering/EventManager';
import { EventsPlugin, setupEventTracking } from '@jumpcloud/ui-events-vue3';
import SignupApi from 'client/signup/api/SignupApi';
import TestIdMixin from 'client/signup/mixins/TestIdMixin';
import router from 'client/signup/routes/Router';
import pinia from './signup/stores/index';
import { useSignupStore } from './signup/stores/useSignupStore';
import { useExperimentsStore } from './signup/stores/useExperimentsStore';
import { createHead } from '@unhead/vue/client';
import { createApp } from 'vue';

const head = createHead();

window.Buffer = Buffer;

(async () => {
  // Create app with Pinia before using stores
  // eslint-disable-next-line vue/require-name-property
  const app = createApp({})
    .use(pinia)
    .use(router)
    .use(head)
    .use(EventsPlugin)
    .mixin(TestIdMixin);

  try {
    // Ensure awating config service does not hang forever
    const configServiceTimeout = setTimeout(() => { throw new Error('request timeout'); }, 5000);
    await ConfigService.initialize();
    window.clearTimeout(configServiceTimeout);

    DataDog.initialize({ serviceName: 'signup' });

    const signupStore = useSignupStore();
    const experimentsStore = useExperimentsStore();

    // determine visitor ID
    const visitorId = signupStore.getVisitorId;
    signupStore.updateVisitorId(visitorId);

    await experimentsStore.initializeExperiments();

    if (ConfigService.disableAnalytics) {
      window.analytics = undefined;
    } else {
      // determine segmentUuid
      const segmentUuid = signupStore.getSegmentUuid;
      if (segmentUuid) signupStore.updateSegmentUuid(segmentUuid);

      setupEventTracking({
        writeKey: ConfigService.segmentScriptWriteKey,
      });

      dreamdataBootstrap.initializeDreamdataBootstrap();
    }

    EventManager.initialize();
  } catch (e) {
    // eslint-disable-next-line  no-console
    console.error(`Error during application initialization: ${e.toString()}`);
  }

  SignupApi.initialize();

  // Always mount the app, regardless of initialization success/failure
  app.mount('#signup-container');
})();
